export default __webpack_public_path__ + "static/media/place-6.ce0c8cab.jpg";